var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedZoneThreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3678_16846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 11.8453C1.8 16.8422 0.0984375 21 0.0609375 21.0844L0 21.2344H1.11094H2.22656L5.30625 12L8.38125 2.76562H7.97344H7.56094L3.84375 11.8453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6941 12L21.7738 21.2344H22.8895H24.0004L23.9395 21.0844C23.902 21 22.2004 16.8422 20.1566 11.8453L16.4395 2.76562H16.027H15.6191L18.6941 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73195 3.09391C9.71368 3.14721 8.86567 5.38579 7.84953 8.06599C6.83338 10.7487 6 12.9569 6 12.9721C6 12.9924 6.7018 13 8.53305 13H11.0698L11.0917 12.7132C11.1063 12.5584 11.1173 12.368 11.1173 12.2944V12.1624H11.9909H12.8645L12.89 12.5812L12.9156 13H15.456H18L17.9781 12.9264C17.9634 12.8858 17.1301 10.6777 16.1249 8.0203C15.1161 5.36294 14.2754 3.14721 14.2571 3.09391L14.2205 3H13.2665H12.3162L12.3381 3.13198C12.3491 3.20558 12.3637 3.39086 12.3673 3.54569L12.3747 3.82487H11.9945H11.6144L11.6217 3.54569C11.6253 3.39086 11.64 3.20558 11.6509 3.13198L11.6729 3H10.7225H9.7685L9.73195 3.09391ZM12.5026 5.88579C12.5245 6.32995 12.5538 6.85025 12.5684 7.04061L12.5903 7.39086H11.9945H11.3987L11.4207 7.04061C11.4353 6.85025 11.4645 6.32995 11.4864 5.88579L11.534 5.08122H11.9945H12.4551L12.5026 5.88579ZM12.6671 8.81726C12.678 8.93401 12.7036 9.35787 12.7256 9.76396C12.7475 10.1675 12.7731 10.5939 12.784 10.7081L12.806 10.9188H11.9945H11.1831L11.205 10.7081C11.216 10.5939 11.2415 10.1675 11.2635 9.76396C11.2854 9.35787 11.311 8.93401 11.322 8.81726L11.3439 8.60914H11.9945H12.6451L12.6671 8.81726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0781,
    y: 3,
    width: 1.84615,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0781,
    y: 3,
    width: 1.84615,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 6.12371,
    y2: -0.75,
    transform: "matrix(0.820571 -0.571545 0.820571 0.571545 10 19.5)",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 6.12371,
    y2: -0.75,
    transform: "matrix(0.820571 0.571545 -0.820571 0.571545 9 16)",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3678_16846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedZoneThreat);
export default __webpack_public_path__ + "static/media/red-zone-threat.e79c483ac585a5886638237c2762fd0a.svg";
export { ForwardRef as ReactComponent };